<template>
    <div
        v-show="estado.visivel"
        class="barra-progresso-navegacao"
        role="progressbar"
        aria-label="Carregando a tela"
        aria-valuemin="0"
        aria-valuemax="100"
        :aria-valuenow="Math.round(estado.progresso)"
    >
        <div
            class="barra-progresso-navegacao__preenchimento"
            :class="{ 'barra-progresso-navegacao__preenchimento--concluindo': estado.concluindo }"
            :style="{ width: estado.progresso + '%' }"
        />
    </div>
</template>

<script>
import { estadoProgresso } from '@/libs/navegacao/progressoNavegacao'

export default {
    name: 'BarraProgressoNavegacao',
    computed: {
        // O estado vive fora da árvore de componentes porque quem o movimenta é
        // o router (ver `libs/navegacao/progressoNavegacao.js`). Já é um
        // `Vue.observable`, então o acesso no template é reativo.
        estado() {
            return estadoProgresso
        },
    },
}
</script>

<style lang="scss">
.barra-progresso-navegacao {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 3px;
    // Acima da navbar fixa, do backdrop de modal (1040) e do modal (1050): a
    // navegação pode começar a partir de um modal aberto (ex.: a modal de
    // Ordem de Serviço), e nesses casos a barra precisa continuar visível.
    z-index: 2000;
    // Faixa decorativa no topo da tela: não pode roubar clique de nada.
    pointer-events: none;
    background-color: transparent;
}

.barra-progresso-navegacao__preenchimento {
    height: 100%;
    background-color: var(--primary);
    // O brilho usa o primary do tema em RGB literal porque não existe uma custom
    // property `--primary-rgb` neste projeto — é enfeite, e um valor fixo aqui
    // não quebra nada se a skin mudar.
    box-shadow: 0 0 8px rgba(115, 103, 240, 0.7);
    border-radius: 0 2px 2px 0;
    // A transição de largura acompanha a cadência do avanço no JS
    // (INTERVALO_AVANCO_MS), senão a barra anda aos saltos.
    transition: width 0.18s linear, opacity 0.2s ease-out;
}

.barra-progresso-navegacao__preenchimento--concluindo {
    opacity: 0;
    // No fim a barra corre até 100% mais rápido do que avançava, para o
    // encerramento parecer conclusão e não mais uma etapa.
    transition: width 0.12s ease-out, opacity 0.2s ease-out;
}
</style>
